import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  background-color: #f9f9f9;
  padding: 10px;
  border-top: 1px solid #f0f1f2;
`;

export const ClockIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 6px;
`;

export const LinkA = styled.a`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  line-height: 18px;
  text-decoration: none;
`;

export const LinkImg = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const LinkText = styled.span`
  font-size: 12px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue;
  cursor: pointer;
`;
